import { connect, mapReadPretty, mapProps } from "@formily/react";
import { Checkbox as CheckboxBase } from "../base/Checkbox";
import { isField } from "@formily/core";

export const Checkbox = connect(
  CheckboxBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      value: field.value,
      onChange: (value) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => {
    return `${props.value ? "Yes" : "No"}`;
  }),
);
